import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Code2, Loader2, Lock, KeyRound } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 10) {
      toast.warning("Das Passwort muss mindestens 10 Zeichen lang sein.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Passwort zurückgesetzt! Du kannst dich jetzt anmelden.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <div className="h-9 w-9 bg-primary border-2 border-black rounded-lg flex items-center justify-center nb-shadow-sm">
            <Code2 className="h-5 w-5 text-white" strokeWidth={2.5} />
          </div>
          <span className="font-heading font-black text-xl">DevPath</span>
        </Link>
        <div className="nb-card p-6">
          <div className="h-12 w-12 bg-accent border-2 border-black rounded-xl flex items-center justify-center nb-shadow-sm mb-4">
            <KeyRound className="h-6 w-6" strokeWidth={2.5} />
          </div>
          <h1 className="font-heading font-black text-2xl mb-2">Neues Passwort</h1>
          <p className="text-muted-foreground font-medium mb-6 text-sm">Wähle ein neues, sicheres Passwort.</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="font-bold text-sm">Reset-Token</label>
              <input
                required
                value={token}
                onChange={(e) => setToken(e.target.value)}
                data-testid="reset-token"
                className="w-full mt-1 px-4 py-3 border-2 border-black rounded-lg font-medium text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="Token aus der E-Mail"
              />
            </div>
            <div>
              <label className="font-bold text-sm">Neues Passwort</label>
              <div className="relative mt-1">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" strokeWidth={2.5} />
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  data-testid="reset-password"
                  className="w-full pl-10 pr-4 py-3 border-2 border-black rounded-lg font-medium focus:outline-none focus:ring-2 focus:ring-primary"
                  placeholder="Mind. 10 Zeichen"
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="reset-submit"
              className="w-full flex items-center justify-center gap-2 bg-primary text-white font-bold py-3 rounded-lg border-2 border-black nb-shadow nb-press disabled:opacity-60"
            >
              {loading && <Loader2 className="h-4 w-4 animate-spin" strokeWidth={2.5} />}
              Passwort speichern
            </button>
          </form>

          <p className="text-center mt-6 font-medium text-sm">
            <Link to="/login" className="font-bold text-secondary underline">Zurück zum Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
